import React, { useContext, useState, useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { GlobalContext } from '../context/provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faGraduationCap, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faNewspaper as faNewspaperRegular } from '@fortawesome/free-regular-svg-icons';

            
import useStudent from '../hooks/useStudent';


import '../styles/bottomTabNav.css';

const BottomTabNav = () => {
  const {
    authState: { authData },
    // noteState: { newNotifNo },
  } = useContext(GlobalContext);

  const newNotifNo = 1;
  const { getCart } = useStudent();
  const [cartItemCount, setCartItemCount] = useState(0);

  useEffect(() => {
    loadCartCount();
  }, []);

  useEffect(() => {
    loadCartCount();
    // Listen for cart update events
    const handleCartUpdate = () => {
      loadCartCount();
    };
    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [authData?.id]);

  const loadCartCount = async () => {
    if (authData?.id) {
      const response = await getCart(authData.id);
      if (response.success && response.data) {
        setCartItemCount(response.data.itemCount || 0);
      }
    }
  };

  const dashboardPath = {
    admin: "/admin/dashboard",
    instructor: "/instructor/dashboard",
    student: "/student/dashboard"
  }[authData.role] ?? "/home";
  
  return (
    <div className="tab-layout">
      <nav className="tab-bar">

        <NavLink to={dashboardPath} className="tab-link">
          <FontAwesomeIcon icon={faHome} />
          <span>Home</span>
        </NavLink>
        
        {/* <NavLink to="/home" className="tab-link">
          <FontAwesomeIcon icon={faHome} />
          <span>Home</span>
        </NavLink> */}

        {/* {authData.role === 'admin' && ( */}
          <NavLink to="/courses" className="tab-link">
            <FontAwesomeIcon icon={faGraduationCap} />
            <span>Courses</span>
          </NavLink>
        {/* )} */}

        {/* {authData.role === 'admin' && ( */}
          <NavLink to="/cart" className="tab-link">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faShoppingCart} />
                {cartItemCount > 0 && 
                  <span style={{ 
                    position: 'absolute', 
                    top: '-10px', 
                    right: '-16px',
                    backgroundColor: '#e71029ff',
                    color: '#fff',
                    width: '18px',
                    height: '18px',
                    borderRadius: '9px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    animation: 'pulse 1s ease-in-out infinite'
                  }}> 
                    {cartItemCount} 
                  </span>
                }
            </div>
            <span>Cart</span>
          </NavLink>
        {/* )} */}

        {authData.role === 'admin' && (
          <NavLink to="/knowledgesharing" className="tab-link">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faNewspaperRegular} />
                {newNotifNo > 0 && 
                  <span style={{ 
                    position: 'absolute', 
                    top: '-10px', 
                    right: '-16px',
                    backgroundColor: '#e71029ff',
                    color: '#fff',
                    width: '18px',
                    height: '18px',
                    borderRadius: '9px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    animation: 'pulse 1s ease-in-out infinite'
                  }}> 
                    {newNotifNo} 
                  </span>
                }
            </div>
            <span>News</span>
          </NavLink>
        )}

      </nav>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
};

export default BottomTabNav;